/**
 * @brief Declaration of vue-router routes
 * @bug No known bugs.
 **/

export const routes = [
  {
    path: '/master',
    name: 'external',
    component: () => import(/* webpackChunkName: "master" */ '@/views/Master.vue'),
  },
  {
    path: '/',
    name: 'home',
    component: () => import(/* webpackChunkName: "home" */ '@/views/Home.vue'),
  },
  {
    path: '/login',
    name: 'login',
    component: () => import(/* webpackChunkName: "login" */ '@/views/Login.vue'),
  },
  {
    path: '/game',
    name: 'game',
    component: () => import(/* webpackChunkName: "game" */ '@/views/Game.vue'),
  },
  {
    path: '/preview/:scenarioId/:stepId',
    name: 'preview',
    component: () => import(/* webpackChunkName: "game" */ '@/views/Preview.vue'),
  },
  {
    path: '/generator',
    name: 'generator',
    component: () => import(/* webpackChunkName: "game" */ '@/views/Generator.vue'),
  },
  {
    path: '/ranking',
    name: 'ranking',
    component: () => import(/* webpackChunkName: "ranking" */ '@/views/Ranking.vue'),
  }
]
